<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    console.error = function () {};
    console.log = function() {};
  },
  methods: {},
};
</script>

<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  min-width: 1000px;
  width: 100%;
  overflow-x: auto;
}

#app {
  min-width: 1000px;
  width: 100%;
  height: 100%;
  overflow-x: hidden; // 防止水平滚动条
}

// 全局容器类，用于限制内容宽度
.container {
  width: 1440px;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
}

// 全屏宽度类，用于需要占满屏幕宽度的元素
.full-width {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}

.txt-link {
  color: #488eff;
  cursor: pointer;
  font-size: 14px;
  text-decoration: none;
}

.txt-blue {
  color: #488eff !important;
  font-size: 14px;
  font-weight: 500;
}

.gray-link {
  color: #666;
  cursor: pointer;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-decoration: none;
}

// 添加全局固定宽度类
.fixed-width-container {
  margin: 0 auto;
  box-sizing: border-box;
}

.logo-image {
  display: flex;
  align-items: center;
  .logo-image-img {
    //width: 37px;
    height: 37px;
  }
  .logo-right {
    height: 100%;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
  }
}
.rejected {
  color: red;
}
.processing {
  color: #E99D42;
}

.open {
  color: #67c23a;
}

.pending {
  color: #409eff;
}
</style>
